'use strict';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var Util = {
  // 参数编码返回字符串
  parseParam: function parseParam(data) {
    var params = "";

    for (var e in data) {
      if (e && data[e]) {
        params += encodeURIComponent(e) + "=" + encodeURIComponent(data[e]) + "&";
      }
    }

    if (params) {
      return params.substring(0, params.length - 1);
    }

    return params;
  },
  getCookie: function getCookie(key) {
    try {
      var reg = new RegExp("(^| )".concat(key, "=([^;]*)(;|$)"));
      var arr = document.cookie.match(reg);
      if (arr) return decodeURIComponent(arr[2]);
    } catch (e) {
      console.log(e);
    }

    return null;
  },
  getDomain: function getDomain() {
    var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;

    if (hostname === 'localhost' || Number(hostname.replace(/\./g, "")) > 0) {
      return hostname;
    }

    return hostname.slice(hostname.indexOf('.'), hostname.length);
  },
  setCookie: function setCookie(key, value, expiredays) {
    // 获取当前域名的 domain
    var domain = this.getDomain();

    if (expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie = "".concat(key, "=").concat(encodeURIComponent(value), ";expires=").concat(exdate.toUTCString(), ";domain=").concat(domain, ";path=/");
    } else {
      document.cookie = "".concat(key, "=").concat(encodeURIComponent(value), ";domain=").concat(domain, ";path=/");
    }
  },
  // 获取url
  getQueryString: function getQueryString(name) {
    var reg = new RegExp("(^|&?)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  uuid: function uuid(len, radix) {
    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
    var uuid = [],
        i;
    radix = radix || chars.length;

    if (len) {
      // Compact form
      for (i = 0; i < len; i++) {
        uuid[i] = chars[0 | Math.random() * radix];
      }
    } else {
      // rfc4122, version 4 form
      var r; // rfc4122 requires these characters

      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
      uuid[14] = "4"; // Fill in random data.  At i==19 set the high bits of clock sequence as
      // per rfc4122, sec. 4.1.5

      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
        }
      }
    }

    return uuid.join("");
  },
  urlToObj: function urlToObj() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
    // 箭头函数默认传值为当前页面url
    var obj = {},
        index = url.indexOf("?"),
        // 看url有没有参数
    params = url.substr(index + 1); // 截取url参数部分 id = 1 & type = 2

    if (index != -1) {
      // 有参数时
      var parr = params.split("&"); // 将参数分割成数组 ["id = 1 ", " type = 2"]

      var _iterator = _createForOfIteratorHelper(parr),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          // 遍历数组
          var arr = i.split("="); // 1） i id = 1   arr = [id, 1]  2）i type = 2  arr = [type, 2]

          obj[arr[0]] = arr[1]; // obj[arr[0]] = id, obj.id = 1   obj[arr[0]] = type, obj.type = 2
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return obj;
  },
  transformObjItemToString: function transformObjItemToString(obj) {
    for (var i in obj) {
      if (_typeof(obj[i]) === 'object') {
        obj[i] = JSON.stringify(obj[i]);
      }
    }

    return obj;
  },
  getUrlPath: function getUrlPath(url) {
    url = new URL(url);
    return url.pathname;
  }
};

var name = "@jushuitan/jst-track";
var version = "1.1.0";
var description = "聚水潭前端SLS日志埋点";
var main = "index.js";
var scripts = {
	dev: "cross-env REACT_APP_ENV=cdn rollup --config --watch",
	build: "npm run build:cdn && npm run build:npm",
	"build:cdn": "cross-env REACT_APP_ENV=cdn rollup --config",
	"build:npm": "cross-env REACT_APP_ENV=npm rollup --config",
	release: "npm run build:npm && npm publish",
	prettier: "prettier --write \"**/*.{js,jsx,tsx,ts,less,md,json}\""
};
var publishConfig = {
	access: "public"
};
var gitHooks = {
	"pre-commit": "lint-staged"
};
var repository = {
	type: "git",
	url: "http://gitlab.jushuitan-inc.com:8081/jst_fe_organization/jst-track"
};
var keywords = [
	"track",
	"pv",
	"uv",
	"click-event"
];
var author = "jushuitan";
var license = "ISC";
var devDependencies = {
	"@babel/core": "^7.6.2",
	"@babel/preset-env": "^7.6.2",
	rollup: "^1.21.4",
	"rollup-plugin-babel": "^4.3.3",
	"rollup-plugin-commonjs": "^10.1.0",
	"rollup-plugin-json": "^4.0.0",
	"rollup-plugin-node-builtins": "^2.1.2",
	"rollup-plugin-node-globals": "^1.4.0",
	"rollup-plugin-node-resolve": "^5.2.0",
	"rollup-plugin-peer-deps-external": "^2.2.0",
	prettier: "^2.2.1",
	"cross-env": "^7.0.3"
};
var pkg = {
	name: name,
	version: version,
	description: description,
	main: main,
	scripts: scripts,
	publishConfig: publishConfig,
	gitHooks: gitHooks,
	"lint-staged": {
	"*.{js,jsx,less,md,json}": [
		"prettier --write"
	],
	"*.ts?(x)": [
		"prettier --parser=typescript --write"
	]
},
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	devDependencies: devDependencies
};

function init() {
  if (!localStorage.getItem('device_id')) {
    localStorage.setItem('device_id', Util.uuid(12));
  }
}

init();
var getParams = function getParams(params) {
  return _objectSpread2({
    domain: window.document.domain,
    page_name: document.title,
    sdk_type: 'web',
    //sdk类型
    device_id: localStorage.getItem('device_id'),
    //设备信息
    local_time: new Date().getTime(),
    //用户本地时间
    refer: document.referrer && Util.getUrlPath(document.referrer),
    //上一个页面
    refer_args: document.referrer && Util.urlToObj(document.referrer),
    //上个页面url参数
    page: window.location.pathname,
    //当前页面唯一标志
    page_args: Util.urlToObj(),
    //当前页面url参数
    sdk_version: pkg.version,
    // SDK版本
    resolution: window.screen.availWidth + "*" + window.screen.availHeight,
    // 分辨率
    os: navigator.userAgent,
    // 操作系统：Android、IOS、WebView
    app_language: navigator.language
  }, params);
};

//聚水塔内账号
var Config = {
  "default": {
    host: 'cn-hangzhou.log.aliyuncs.com',
    project: 'jstweb',
    logstore: 'web-track',
    time: 10,
    count: 10
  },
  'overseas': {
    host: 'ap-southeast-1.log.aliyuncs.com',
    project: 'jst-global-log',
    logstore: 'web-track',
    time: 10,
    count: 10
  }
};

var _excluded = ["aliyunHost"],
    _excluded2 = ["nextPageSend", "send_type"];

function sendPreTrack() {
  // 判断浏览器中是否有上次未发送的数据，如果有直接发送
  var preTrackObj = localStorage.getItem("preTrack");

  if (preTrackObj) {
    sendTrackData(JSON.parse(preTrackObj));
    localStorage.removeItem("preTrack");
  }
}

sendPreTrack();

function sendParamsFromImg(setParams) {
  var aliyunHost = setParams.aliyunHost,
      reset = _objectWithoutProperties(setParams, _excluded);

  var img = new Image(1, 1);

  img.onerror = function () {// 这里可以进行重试操作
  };

  var opts = Config[aliyunHost === 'overseas' ? 'overseas' : 'default'];
  var url = "https://".concat(opts.project, ".").concat(opts.host, "/logstores/").concat(opts.logstore, "/track.gif?APIVersion=0.6.0&");
  img.src = url + Util.parseParam(Util.transformObjItemToString(reset));
} //发送一张图片


function sendTrackData() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var nextPageSend = params.nextPageSend,
      send_type = params.send_type,
      other = _objectWithoutProperties(params, _excluded2);

  var setParams = _objectSpread2(_objectSpread2({}, getParams(other)), {}, {
    is_track_prod: params.is_track_prod || window['is_track_prod']
  });

  if (nextPageSend) {
    localStorage.setItem("preTrack", JSON.stringify(setParams));
    return;
  } //如果是生产环境才发送请求，否则只打印日志


  if (setParams.is_track_prod) {
    sendParamsFromImg(setParams);
  } else {
    console.log(setParams);
  }
}

module.exports = sendTrackData;
